import { defineMessages } from 'react-intl';

const translationsError = defineMessages({
  LANDSCAPE_CAPTION_TITLE: {
    id: 'LANDSCAPE_CAPTION_TITLE',
    defaultMessage: `A better way to perform vehicle inspections.`,
  },
  LANDSCAPE_CAPTION_DESCRIPTION: {
    id: 'LANDSCAPE_CAPTION_DESCRIPTION',
    defaultMessage: `Turn any phone into your professional vehicle inspector with PAVE.`,
  },
  HOME_PAVE_3: {
    id: 'HOME_PAVE_3',
    defaultMessage: `HOW IT WORKS`,
  },
  LANDSCAPE_CAPTION_CONTENT_INSTRUCTION_2: {
    id: 'LANDSCAPE_CAPTION_CONTENT_INSTRUCTION_2',
    defaultMessage: `Simply go to your vehicle and park in a safe place that allows you to take clear photos from all angles.`,
  },
  LANDSCAPE_CAPTION_CONTENT_INSTRUCTION_3: {
    id: 'LANDSCAPE_CAPTION_CONTENT_INSTRUCTION_3',
    defaultMessage: `When you're ready, rotate your device and click Get Started.`,
  },
  HOME_PAVE_6: {
    id: 'HOME_PAVE_6',
    defaultMessage: `Get Started`,
  },
  CONFIRM_COMPLETE_1: {
    id: 'CONFIRM_COMPLETE_1',
    defaultMessage: `CONFIRMED - COMPLETED`,
  },
  CONFIRM_COMPLETE_2: {
    id: 'CONFIRM_COMPLETE_2',
    defaultMessage: `Please wait for a while.`,
  },
  DEVICE_ERROR_CAPTION_NOT_FOUND: {
    id: 'DEVICE_ERROR_CAPTION_NOT_FOUND',
    defaultMessage: `ERROR`,
  },
  DEVICE_ERROR_CAPTION_NOT_FOUND_PAGE: {
    id: 'DEVICE_ERROR_CAPTION_NOT_FOUND_PAGE',
    defaultMessage: `Page not found`,
  },
  DEVICE_ERROR_CAPTION_NOT_FOUND_SUBCAPS: {
    id: 'DEVICE_ERROR_CAPTION_NOT_FOUND_SUBCAPS',
    defaultMessage: `We've detected you're viewing this link from a desktop computer or other unsupported device.`,
  },
  RETAKE_PHOTO_1: {
    id: 'RETAKE_PHOTO_1',
    defaultMessage: `PHOTO ISSUE!`,
  },
  RETAKE_PHOTO_2: {
    id: 'RETAKE_PHOTO_2',
    defaultMessage: `Your photo was rejected for reason`,
  },
  // RETAKE_PHOTO_3: {
  // 	id: 'RETAKE_PHOTO_3',
  // 	defaultMessage: ``
  // },
  RETAKE_PHOTO_4: {
    id: 'RETAKE_PHOTO_4',
    defaultMessage: `please retake your photo.`,
  },
  RETAKE_PHOTO_5: {
    id: 'RETAKE_PHOTO_5',
    defaultMessage: `RETAKE PHOTO`,
  },
  ROTATE_CAMERA_1: {
    id: 'ROTATE_CAMERA_1',
    defaultMessage: `Error!`,
  },
  ROTATE_CAMERA_2: {
    id: 'ROTATE_CAMERA_2',
    defaultMessage: `Please rotate your device to landscape mode to continue to use PAVE.`,
  },
  ROTATE_CAMERA_3: {
    id: 'ROTATE_CAMERA_3',
    defaultMessage: `ROTATE TO CONTINUE`,
  },
  SWIPE_TO_FORCE_FULLSCREEN: {
    id: 'SWIPE_TO_FORCE_FULLSCREEN',
    defaultMessage: `Swipe down then up to hide toolbar for a full screen experience.`,
  },
  SWIPE_TO_FORCE_FULLSCREEN_BTN: {
    id: 'SWIPE_TO_FORCE_FULLSCREEN_BTN',
    defaultMessage: `Skip`,
  },
  PAVE_INVALID_SESSION_ID: {
    id: 'PAVE_INVALID_SESSION_ID',
    defaultMessage: `Your sessionID's invalid`,
  },
  PAVE_UPLOADED_SUCCESS_ALL: {
    id: 'PAVE_UPLOADED_SUCCESS_ALL',
    defaultMessage: `All your photos were uploaded successfully.`,
  },
  PAVE_UPLOADED_MISSING: {
    id: 'PAVE_UPLOADED_MISSING',
    defaultMessage: `Some your photos were missing, please try again later`,
  },
  PAVE_UPLOADING_LITE: {
    id: 'PAVE_UPLOADING_LITE',
    defaultMessage: `Uploading ..`,
  },
  PAVE_LITE_MAX_UPLOAD: {
    id: 'PAVE_LITE_MAX_UPLOAD',
    defaultMessage: `Maximum upload 30 photos`,
  },
  PAVE_LITE_FINISH: {
    id: 'PAVE_LITE_FINISH',
    defaultMessage: `Finish`,
  },
  PAVE_MESS_TOUCH: {
    id: 'PAVE_MESS_TOUCH',
    defaultMessage: `Touch anywhere to cancel auto advance`,
  },
  ROTATE_PORTRAIT_UI_TITLE: {
    id: 'ROTATE_PORTRAIT_UI_TITLE',
    defaultMessage: `User Tip :`,
  },
  ROTATE_PORTRAIT_UI_CAPTION: {
    id: 'ROTATE_PORTRAIT_UI_CAPTION',
    defaultMessage: `Unlock your display mode to allow your screen to rotate
    automatically`,
  },
});
export default translationsError;
